import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=1236bea0&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=1236bea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236bea0",
  null
  
)

export default component.exports